import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import fullSetImg from '../../dubai/assets/images/full-set-img.png'
import halfSetImg from '../../dubai/assets/images/half-set-img.png'
import { id } from 'date-fns/locale'
import Slider from "react-slick";

const FullSetHalfSet = () => {

    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const fullhalfData = [
        {
            id: 1,
            bgImg: fullSetImg,
            heading: "Full Set",
            subHeading: "Lorem Ipsum is simply dummy text",
            btnUrl: "#",
            btnText: "shop Now",
        },
        {
            id: 2,
            bgImg: halfSetImg,
            heading: "Half Set",
            subHeading: "Lorem Ipsum is simply dummy text",
            btnUrl: "#",
            btnText: "shop Now",
        },  
    ]

    return (
        <div className='du_fullSetHalfSet_section'>
            <Container className='dubai-showcase-container '>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <Slider {...settings} className="su_fullset_halfset_slider">
                          {fullhalfData.map((item, index) => (

                           <div className='du_hf_slider_outer'>
                                <div className='du_hf_slider_inner' style={{ backgroundImage: `url(${item.bgImg})`, backgroundSize: "cover", backgroundPosition: "center"}}>
                                  <div className='du_hf_slider_inner_inner'>
                                  <h2>{item.heading}</h2>
                                    <p>{item.subHeading}</p>
                                    <button className='du_shop_now_btn'>{item.btnText}</button>
                                  </div>
                                </div>
                            </div>
                          ))
                            
                          } 

                        </Slider>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default FullSetHalfSet
